import Vue from 'vue';
import Antd, { message, Modal } from 'ant-design-vue';
import '../static/theme.less';
message.config({
	top: '10%',
	duration: 2
});

Vue.use(Antd);
